export const DEFAULT_AD_IMAGES_TO_LOAD = 4;



// WEBPACK FOOTER //
// ./app/Serp/components/Lists/ListAds/constants.js